(function () {
  const bindTouchPause = ($ticker) => {
    if ($ticker.hasClass('touch_pause_bound')) {
      return;
    }
    $ticker.addClass('touch_pause_bound');

    $ticker.on('touchstart', function () {
      $(this).addClass('ticker--paused');
    });
    $ticker.on('touchend touchcancel', function () {
      $(this).removeClass('ticker--paused');
    });
  };

  const tickSlider = () => {
		$(".ticker").each(function(){
			const $ticker = $(this);
			const isScrolling = $ticker.data('scroll-mode') === true;

			if (isScrolling) {
				bindTouchPause($ticker);
				return '';
			}

			if ($ticker.hasClass('slider_started')) {
				return '';
			}
			$ticker.addClass('slider_started');
			const tickerId = $ticker.data('ticker-id');

			new Swiper(`.ticker-js-${tickerId}`, {
				slidesPerView: 1,
				loop: $ticker.find('.swiper-slide').length > 1,
				speed: 500,
				allowTouchMove: true,
				navigation: {
					nextEl: this.querySelector('.ticker__arrow--next'),
					prevEl: this.querySelector('.ticker__arrow--prev'),
				},
			});
		})
  };

  tickSlider();
  document.addEventListener("shopify:section:load", function () {
    setTimeout(() => {
      tickSlider();
    }, 100);
  });

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) {
      $(".ticker-js").each(function () {
        this.swiper.destroy();
      });
      tickSlider();
    }
  });

  setTimeout(() => {
    tickSlider();
  }, 100);
})();

// Marquee mode: JS-driven loop so visitors can drag, swipe or trackpad-scroll the ticker
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initMarquee = (ticker) => {
    if (ticker.dataset.marqueeBound) return;
    const track = ticker.querySelector('.ticker__track');
    const groups = ticker.querySelectorAll('.ticker__track-group');
    if (!track || groups.length < 2) return;
    ticker.dataset.marqueeBound = 'true';
    ticker.classList.add('ticker--js');

    const duration = parseFloat(track.style.animationDuration) || 60;
    let x = 0;
    let span = 0;
    let speed = 0;
    let hovering = false;
    let dragging = false;
    let dragMoved = 0;
    let lastPointerX = 0;
    let lastTime = performance.now();

    const measure = () => {
      span = groups[1].offsetLeft - groups[0].offsetLeft;
      speed = span / duration;
    };
    const wrap = () => {
      if (!span) return;
      while (x <= -span) x += span;
      while (x > 0) x -= span;
    };
    const render = () => {
      track.style.transform = `translate3d(${x}px, 0, 0)`;
    };
    const tick = (now) => {
      const dt = Math.min((now - lastTime) / 1000, 0.1);
      lastTime = now;
      const paused = hovering || dragging || ticker.classList.contains('ticker--paused') || reduceMotion.matches;
      if (!paused) {
        x -= speed * dt;
        wrap();
        render();
      }
      requestAnimationFrame(tick);
    };

    ticker.addEventListener('mouseenter', () => (hovering = true));
    ticker.addEventListener('mouseleave', () => (hovering = false));

    ticker.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      dragMoved = 0;
      lastPointerX = e.clientX;
    });
    window.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - lastPointerX;
      lastPointerX = e.clientX;
      dragMoved += Math.abs(dx);
      if (dragMoved > 4) ticker.classList.add('ticker--dragging');
      x += dx;
      wrap();
      render();
    });
    const endDrag = () => {
      dragging = false;
      ticker.classList.remove('ticker--dragging');
    };
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // A drag that ends over a button should not also click it
    ticker.addEventListener('click', (e) => {
      if (dragMoved > 4) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    ticker.addEventListener('dragstart', (e) => e.preventDefault());

    ticker.addEventListener('wheel', (e) => {
      const dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.shiftKey ? e.deltaY : 0;
      if (!dx) return;
      e.preventDefault();
      x -= dx;
      wrap();
      render();
    }, { passive: false });

    measure();
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    render();
    requestAnimationFrame(tick);
  };

  const initAll = () => {
    document.querySelectorAll('.ticker[data-scroll-mode="true"]').forEach(initMarquee);
  };

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
